import { FaDisplay } from "react-icons/fa6";
import "./TelaInicialAtivacaoGroupSign.css";
import CustomButton from "shared/components/button/CustomButton";
import { useNavigate } from "react-router-dom";
import { Rotas } from "constants/EnumRotas";
import { useContext, useState } from "react";
import { FaLock, FaRegClock } from "react-icons/fa";
import imagemTelaInicialAtivacao from "../../../static/cloud21/groupsign/tela-ativacao-group-sign.png";
import logoGroupCondominios from "../../../static/cloud21/sidebar/logo-group-condominios.png";
import logoGroupEstrelas from "../../../static/cloud21/groupsign/produto-group-software-estrelas.png";
import circuloFooter from "../../../static/cloud21/groupsign/circulo-footer-group-sign.png";
import { Card, CardContent } from "@mui/material";
import { UserContext } from "context/UserContext";
import { usePostAtivarGroupSign } from "hooks/groupsign/usePostAtivarGroupSign";

const TelaInicialAtivacaoGroupSign: React.FC = () => {
  const navigate = useNavigate();
  const { usuarioLogado } = useContext(UserContext);
  const { mutateAsync: postAtivarGroupSign } = usePostAtivarGroupSign(usuarioLogado.codigoSuporte);

  const ativarGroupSign = () => {
    postAtivarGroupSign(usuarioLogado.codigoSuporte).catch((e) => console.log(e));
  };

  const renderHeaderAtivacaoGroupSign = () => {
    return (
      <div className="header-ativacao-group-sign">
          <img 
            src={logoGroupCondominios}
            alt="Logo Group"
            className="logo-superior"
          />

        <h1>
          <b>
            Assinatura digital descomplicada <br/>
             para os seus documentos
          </b>
        </h1>
        <p>
          Otimize sua rotina e garanta segurança jurídica com <br/> 
          nossa solução de assinatura digital integrada.
        </p>


        <div className="container-botao-com-imagem">
            {renderBotaoQueroContratar()}
          <img 
            src={logoGroupEstrelas} 
            alt="5 estrelas" 
            className="imagem-ao-lado-botao"
          />
        </div>
      </div>
    );
  };

  const getStyleIconeCircular = (backgroundColor: string): Object => {
    const style = {
      backgroundColor: backgroundColor,
      width: 55,
      height: 55,
      borderRadius: "50%",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
    return style;
  };

  const renderBodyAtivacaoGroupSign = () => {
    return (
      <div className="container d-flex justify-content-center gap-5 mt-5">
        <Card id={"primeiro-item-anuncio-group-sign"} className="card-group-sign" sx={{borderRadius: '12px'}}>
          <CardContent>
            {renderPrimeiroItemAnuncio()}
          </CardContent>
        </Card>

        <Card id={"segundo-item-anuncio-group-sign"} className="card-group-sign" sx={{borderRadius: '12px'}}>
          <CardContent>
            {renderSegundoItemAnuncio()}
          </CardContent>
        </Card>

        <Card id={"terceiro-item-anuncio-group-sign"} className="card-group-sign" sx={{borderRadius: '12px'}}>
          <CardContent>
            {renderTerceiroItemAnuncio()}
          </CardContent>
        </Card>
      </div>
    );
  };

  const renderPrimeiroItemAnuncio = () => {
    return (
      <div className="item-card-group-sign">
        <div style={getStyleIconeCircular("#158C8C29")}>
          <FaLock size={25} color="#0E5A3C80" />
        </div>
        <h3 className="fs-5 mt-2">
          <b>Segurança</b>
        </h3>
        <div className="fs-10 mt-3 lh-sm">Certificação digital que atende <br/> às normas legais </div>
      </div>
    );
  };

  const renderSegundoItemAnuncio = () => {
    return (
      <div className="item-card-group-sign">
        <div style={getStyleIconeCircular("#f9ecdc")}>
          <FaRegClock size={25} color="#de9b47" />
        </div>
        <h3 className="fs-5 mt-2">
          <b>Economia de Tempo</b>
        </h3>
        <div className="fs-10 mt-3 lh-sm">Coleta de assinaturas sem <br/> deslocamentos ou papelada</div>
      </div>
    );
  };

  const renderTerceiroItemAnuncio = () => {
    return (
      <div className="item-card-group-sign">
        <div style={getStyleIconeCircular("#dceff9")}>
          <FaDisplay size={25} color="#47acde" />
        </div>
        <h3 className="fs-5 mt-2">
          <b>Integração Total</b>
        </h3>
        <div className="fs-10 mt-3">Funciona diretamente no <br/> seu Group Condomínios</div>
      </div>
    );
  };

  const renderFooterGroupSign = () => {
    return (
      <>
        <div className="d-flex flex-column align-items mt-0">
          <div className="mb-3">
            {renderBotaoSolicitarMinhaIntegracao()}
          </div>
          
          <div className="text-center"> 
            Ficou alguma dúvida? Entre em contato <br/>
            com nosso suporte.
          </div>
        </div>

        <img
            src={circuloFooter} 
            alt="circulo footer" 
            className="tela-inicial-group-sign__vector-top-footer-background"
        />  

       <img
            src={circuloFooter} 
            alt="circulo footer" 
            className="tela-inicial-group-sign__vector-bottom-footer-background"
        />
      </>
    )
  }


  const renderBotaoSolicitarMinhaIntegracao = () => {
    return (
      <div>
        <CustomButton
          id="solicitar-minha-integração"
          label="Solicitar minha integração >"
          onClick={() => {
            ativarGroupSign();
          }}
          size="lg"
          bigSize
        />
      </div>
    );
  };

  const renderBotaoQueroContratar = () => {
    return (
      <div>
        <CustomButton
          id="quero-contratar"
          label="Quero contratar >"
          onClick={() => {
            ativarGroupSign();
          }}
          size="lg"
          bigSize
        />
      </div>
    );
  };

  

  return (
    <>
        <div className="container-header-ativacao-group-sign">
          {renderHeaderAtivacaoGroupSign()}
          <div className="imagem-header-container">
              <img 
                  src={imagemTelaInicialAtivacao} 
                  alt="Assinatura digital" 
                  className="imagem-header-principal"
              />
          </div>
        </div>
          <div>{renderBodyAtivacaoGroupSign()}</div>

        <div className="tela-inicial-group-sign__footer-background">
          <div>{renderFooterGroupSign()}</div>
        </div>
    </>
  );
};

export default TelaInicialAtivacaoGroupSign;
